import '@updater-components/tooltip';
import {
  MOVE_DATE_MIN_ISO_8601,
  MOVE_DATE_MAX_ISO_8601,
} from '../../../../constants';
import template from './move-datepicker.html';
import './move-datepicker.global.css';
import '@updater-legacy/components/datepicker';
import '@updater-legacy/components/datepicker/popup';
import '@updater-legacy/components/datepicker/input';

const READONLY_TOOLTIP =
  'You can no longer make changes to your move date because your Mail Forwarding or Account Updates have been processed.';

class MoveDatepickerController {
  constructor($element, $scope) {
    'ngInject';

    this.el = $element;
    this.scope = $scope;
  }

  $postLink() {
    this.popup = this.el[0].querySelector('upd-datepicker-popup');
    this.popup.addEventListener('change', (e) => {
      this.popup.close();
      this.scope.$apply(() => this.change({ date: e.target.value }));
    });
  }

  openPopup() {
    this.popup.open();
  }

  get moveDateMin() {
    return MOVE_DATE_MIN_ISO_8601;
  }

  get moveDateMax() {
    return MOVE_DATE_MAX_ISO_8601;
  }

  get tooltip() {
    return READONLY_TOOLTIP;
  }
}

export const MoveDatepickerComponent = {
  controller: MoveDatepickerController,
  bindings: {
    date: '<',
    change: '&',
    readonly: '<',
  },
  template,
};
